import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Button,
} from "@mindstonehq/ui";
import copy from "copy-to-clipboard";
import { toast } from "@mindstonehq/ui";
import { CopyIcon } from "~/components/icons";
import { GiftIcon } from "@heroicons/react/24/outline";
import { Trans, useLingui } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

export function DiscountCodeDialog({
  open,
  onOpenChange,
  referralCode,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  referralCode: string;
}) {
  const { t } = useLingui();
  const handleCopy = () => {
    if (referralCode) {
      copy(referralCode);
      toast.success(t(msg`Discount code copied to clipboard`));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle><Trans>Discount code</Trans></DialogTitle>
          <DialogDescription>
            <Trans>Use your 20% discount code to join a Mindstone Community program or share it with a friend or colleague interested in AI.</Trans>
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center justify-between mt-4 mb-2">
          <span className="text-sm font-semibold">
            <Trans>Your discount code (private)</Trans>
          </span>
          <GiftIcon className="h-5 w-5 text-muted-foreground" />
        </div>
        <div className="border border-dashed border-border rounded-md px-3 py-2 mb-4">
          <code className="text-sm font-medium">{referralCode}</code>
        </div>
        <Button onClick={handleCopy} className="w-full">
          <CopyIcon className="h-4 w-4 mr-2" />
          <Trans>Copy code</Trans>
        </Button>
      </DialogContent>
    </Dialog>
  );
}
